import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Breakpoint from 'ondemand/components/Breakpoint';

import styles from './FloatingBarLayout.css';

const FloatingBarLayout = ({barContent, bottom, children, desktopMax, leftOffset, mobileMax}) => (
  <Breakpoint maxWidth={mobileMax}>
    {(isMobile) => {
      const barClassName = classNames(styles.bar, {
        [styles.floating]: !isMobile,
        [styles.floatingTop]: !isMobile && !bottom,
        [styles.floatingBottom]: !isMobile && bottom,
      });
      const barStyle = {
        paddingLeft: `${isMobile ? 0 : leftOffset || 0}px`,
      };
      const barContentStyle = {
        maxWidth: `${isMobile ? mobileMax : desktopMax}px`,
      };

      const barNode = (
        <div className={barClassName} style={barStyle}>
          <div className={styles.barContent} style={barContentStyle}>
            {barContent}
          </div>
        </div>
      );

      return (
        <div className={styles.root}>
          {!bottom && barNode}
          <div className={styles.body}>
            <div className={styles.bodyContent}> {/* needed for children with x% height */}
              {children}
            </div>
          </div>
          {bottom && barNode}
        </div>
      );
    }}
  </Breakpoint>
);

FloatingBarLayout.propTypes = {
  barContent: PropTypes.node,
  bottom: PropTypes.bool,
  children: PropTypes.node,
  leftOffset: PropTypes.number,
  desktopMax: PropTypes.number,
  mobileMax: PropTypes.number.isRequired,
};

export default FloatingBarLayout;



// WEBPACK FOOTER //
// ./src/ondemand/components/FloatingBarLayout/FloatingBarLayout.js